import React from 'react'
import { Skeleton, TextSkeleton } from '.'

type Props = {
  slim?: boolean
  noAnimation?: boolean
}

export const ProductCardSkeleton = ({ slim = false, noAnimation = false }: Props) => {
  return (
    <Skeleton
      shade="light"
      className="d-flex flex-wrap u-mb-16 u-px-16 u-py-16"
      noAnimation={noAnimation}>
      <div className="u-px-24">
        <Skeleton
          withLogo
          noAnimation={noAnimation}
          width={slim ? 64 : 150}
          height={slim ? 64 : 150}
        />
      </div>
      <div className="flex-grow-1 u-pr-64">
        <TextSkeleton type="p" noAnimation={noAnimation} />
      </div>
      <div className="d-flex align-items-end justify-content-end">
        <Skeleton shade="dark" width={175} height={36} noAnimation={noAnimation}></Skeleton>
      </div>
    </Skeleton>
  )
}
